import SignOut from 'pages/authentication/sign-out';

export default function SignOutPage() {
  return <SignOut />;
}
